"use client";

import ConfigProvider from "@stadium/hooks/lib/use-config";
import usePathMatcher from "@stadium/hooks/lib/use-path-matcher";

import { ALLOW_SSR_PATHS } from "@constants/routes";
import { SM_PROGRAM_ID, SM_PROGRAM_IDENTIFIER } from "@constants/app-defaults";

const ConfigWrapperClient = ({ children }) => {
  const isSSREnabled = usePathMatcher(ALLOW_SSR_PATHS);

  return (
    <ConfigProvider
      programId={SM_PROGRAM_ID}
      programIdentifier={SM_PROGRAM_IDENTIFIER}
      loadChildrenOnLoading={isSSREnabled}
    >
      {children}
    </ConfigProvider>
  );
};

export default ConfigWrapperClient;
